/**
 * OriginalDataSection Component
 * Displays original data table from uploaded files
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import AnalysisTable from '../../../shared/components/tables/AnalysisTable';
import type { InfoType } from '../types/dataAdjustments.types';

interface OriginalDataSectionProps {
  processedData: { data: { info_df: InfoType[] } } | null;
}

const OriginalDataSection: React.FC<OriginalDataSectionProps> = ({
  processedData
}) => {
  const { t } = useTranslation('dataAdjustments');
  
  // Transform data to AnalysisTable format
  const transformToAnalysisFormatImpl = (data: InfoType) => {
    return {
      fileName: data["Name der Datei"],
      mesurmentName: data["Name der Messreihe"],
      startTime: data["Startzeit (UTC)"],
      endTime: data["Endzeit (UTC)"],
      timeStepSize: data["Zeitschrittweite [min]"],
      offset: data["Offset [min]"],
      dataPoints: data["Anzahl der Datenpunkte"],
      numericDataPoints: data["Anzahl der numerischen Datenpunkte"],
      numericPercentage: Number(data["Anteil an numerischen Datenpunkten"]),
    };
  };

  const originalTableData = processedData?.data?.info_df
    ? processedData.data.info_df.map(transformToAnalysisFormatImpl)
    : [];
  
  if (originalTableData.length === 0) return null;
  
  return (
    <div className="mt-6 mb-8">
      <h2 className="text-xl font-bold mb-4">
        {t('originalData.title')}
      </h2>
      <AnalysisTable analyses={originalTableData} />
    </div>
  );
};

export default OriginalDataSection;
